module.exports = __webpack_public_path__ + "static/media/circle.ae07faeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/circle.svg
// module id = 463
// module chunks = 0